import MaintenanceImg from 'assets/img/maintenance.jpeg'

export function Maintenance() {
  return <img src={MaintenanceImg} alt="" />
}
